
import { useState } from "react";
import { useMarketFetch } from "./useMarketFetch";
import { useMarketToggle } from "./useMarketToggle";
import { useMarketSave } from "./useMarketSave";
import { Market } from "../../markets/marketData";

export const useCurrencyMarkets = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const {
    markets,
    setMarkets,
    loading,
    dbError,
    missingColumns,
    organizationId,
    fetchCurrentMarkets
  } = useMarketFetch();
  
  const { toggleMarketActive } = useMarketToggle(
    markets, 
    setMarkets, 
    organizationId, 
    dbError,
    missingColumns,
    fetchCurrentMarkets
  );
  
  const { saveMarkets } = useMarketSave(
    setMarkets, 
    organizationId, 
    dbError,
    missingColumns
  );

  const defaultMarket = markets.find(m => m.isDefault)?.country || "Algeria";
  const currentActiveMarkets = markets.filter(m => m.isActive).map(m => m.country);

  return {
    markets,
    loading,
    dbError,
    isDialogOpen,
    setIsDialogOpen,
    saveMarkets,
    toggleMarketActive,
    defaultMarket,
    currentActiveMarkets
  };
};
